/**
 * Extracts the error code from a GraphQL error response.
 * Useful for matching against `GraphQLErrorCodes` in catch blocks.
 */
export const getGraphQLErrorCode = (error: any): string | undefined =>
  error?.response?.errors?.[0]?.extensions?.code;
